/* unplugin-vue-components disabled */import { render } from "./SpareParts.vue?vue&type=template&id=3c2ddaaa&scoped=true&ts=true"
import script from "./SpareParts.vue?vue&type=script&lang=ts"
export * from "./SpareParts.vue?vue&type=script&lang=ts"

import "./SpareParts.vue?vue&type=style&index=0&id=3c2ddaaa&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c2ddaaa"]])

export default __exports__